import { render } from "./NotificationsInformerNotification.vue?vue&type=template&id=8ac4f84c&scoped=true"
import script from "./NotificationsInformerNotification.vue?vue&type=script&lang=js"
export * from "./NotificationsInformerNotification.vue?vue&type=script&lang=js"

import "./NotificationsInformerNotification.vue?vue&type=style&index=0&id=8ac4f84c&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac4f84c"]])

export default __exports__